import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ensurePixel } from "../utils/metaPixel";
import { hasMarketingConsent, onConsentChange } from "../utils/cookieConsent";

const MARKETING_PATHS = new Set([
  "/",
  "/termeni-si-conditii",
  "/politica-de-confidentialitate",
  "/politica-gdpr",
  "/politica-de-livrare",
  "/politica-de-rambursare",
  "/ghid-foaie-parcurs-anaf",
  "/deducere-100-combustibil",
  "/foi-parcurs-pfa",
  "/model-foaie-parcurs",
  "/control-anaf-cheltuieli-autoturism",
  "/automatizare-foi-de-parcurs",
  "/foi-parcurs-comodat",
  "/foaie-parcurs-casa-serviciu",
  "/norma-de-consum-foaie-parcurs",
  "/autoutilitara-vs-autoturism-deductibilitate",
  "/ghiduri",
  "/masina-personala-srl-comodat",
  "/decont-kilometri",
]);

let lastPageViewPath: string | null = null;

function isMarketingPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  return MARKETING_PATHS.has(p);
}

export default function MetaPixel() {
  const { pathname } = useLocation();
  const [allowed, setAllowed] = useState(hasMarketingConsent);

  useEffect(
    () =>
      onConsentChange((c) => {
        setAllowed(c.marketing);
        if (!c.marketing) {
          lastPageViewPath = null;
          try {
            window.fbq?.("consent", "revoke");
          } catch {
            // Pixel revoke must never break the app.
          }
        } else {
          try {
            window.fbq?.("consent", "grant");
          } catch {
            // Pixel may not be loaded yet; ensurePixel runs in the effect below.
          }
        }
      }),
    [],
  );

  useEffect(() => {
    if (!allowed) return;
    if (!isMarketingPath(pathname)) {
      lastPageViewPath = null;
      return;
    }

    ensurePixel();
    if (lastPageViewPath === pathname) return;
    lastPageViewPath = pathname;
    window.fbq?.("track", "PageView");
  }, [pathname, allowed]);

  return null;
}
